<template>
  <div>
    <client-only>
      <input :id="placeholder" :placeholder="placeholder" :maxlength="String(max)" class="
                    w-full
                    bg-gray-100
                    text-gray-800
                    border
                    border-secondary
                    text-xs
                    rounded-lg
                    py-2
                    px-3
                    placeholder-gray-500
                    focus:outline-none
                " @focus="isFocused = true" @blur="isFocused = false" :class="isFocused ? 'border-gray-900' : ''"
        :type="inputType" :data-maska="mask" v-maska v-model="inputComputed" autocomplete="off">
    </client-only>
    <span v-if="error" class="text-red-500 text-[14px] font-semibold">
      {{ error }}
    </span>
  </div>

</template>

<script setup>
const emit = defineEmits(['update:input'])
const props = defineProps(['input', 'placeholder', 'mask', 'max', 'inputType', 'error'])
const { input, placeholder, max, inputType, error } = toRefs(props)

let isFocused = ref(false)

const inputComputed = computed({
  get: () => input.value,
  set: (val) => emit('update:input', val)
})
</script>